import { ApiConfig } from '@mri-platform/shared/core';

export class IntelligenceApiConfig extends ApiConfig {}
